import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Container from '../../../layout/Container';
import { socialMediaIconUrls } from '../../../config/socialMediaIcons';
import { socialMediaLinks } from '../../../config/socialMediaLinks';

const platforms: { name: string; color: string; link: string; icon: React.ReactNode }[] = [
    {
        name: 'Instagram',
        color: '#E4405F',
        link: socialMediaLinks.instagram,
        icon: <Box component="img" src={socialMediaIconUrls.instagram()} alt="Instagram" sx={{ width: 28, height: 28, objectFit: 'contain' }} />,
    },
    {
        name: 'Facebook',
        color: '#1877F2',
        link: socialMediaLinks.facebook,
        icon: <Box component="img" src={socialMediaIconUrls.facebook()} alt="Facebook" sx={{ width: 28, height: 28, objectFit: 'contain' }} />,
    },
    {
        name: 'YouTube',
        color: '#FF0000',
        link: socialMediaLinks.youtube,
        icon: <Box component="img" src={socialMediaIconUrls.youtube()} alt="YouTube" sx={{ width: 28, height: 28, objectFit: 'contain' }} />,
    },
    {
        name: 'TikTok',
        color: '#25F4EE',
        link: socialMediaLinks.tiktok,
        icon: <Box component="img" src={socialMediaIconUrls.tiktok()} alt="TikTok" sx={{ width: 28, height: 28, objectFit: 'contain' }} />,
    },
];

const HomeFollowUsSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ pt: 4, px: 2 }}>
            <Container>
                <Box display="flex" flexDirection="column" alignItems="center" gap={1.5}>
                    <Typography variant="h5" fontWeight={700} color="text.primary" sx={{ letterSpacing: '0.02em' }}>
                        {t('footer.followUs')}
                    </Typography>
                    <Typography variant="body2" color="text2.primary" sx={{ maxWidth: 360, textAlign: 'center' }}>
                        {t('home.followUsSubtitle')}
                    </Typography>
                    <Box display="flex" flexDirection="row" gap={3} flexWrap="wrap" justifyContent="center">
                        {platforms.map(({ name, icon, color, link }) => (
                            <IconButton
                                key={name}
                                onClick={() => window.open(link)}
                                aria-label={name}
                                sx={(theme) => ({
                                    width: 56,
                                    height: 56,
                                    backgroundColor: theme.palette.background.paper,
                                    border: `2px solid ${color}`,
                                    transition: 'all 0.25s ease',
                                    '&:hover': {
                                        backgroundColor: theme.palette.action.hover,
                                    },
                                })}
                            >
                                {icon}
                            </IconButton>
                        ))}
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default HomeFollowUsSection;
